// extracted by mini-css-extract-plugin
export default {"icon":"FullAddressPicker_icon__4vCzC","wrapper":"FullAddressPicker_wrapper__1aNRK","expandLess":"FullAddressPicker_expandLess__2V4R5","label":"FullAddressPicker_label__1W7Qn"};